module.exports = __webpack_public_path__ + "img/CLICX.89e86353.png";